"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var paymentStatusReceiptLoad_1 = require("./paymentStatusReceiptLoad");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.PaymentStatusReceiptEventNames.PaymentStatusReceipt] = paymentStatusReceiptLoad_1.paymentStatusReceiptLoad,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
